import { useWorkspace } from "./useWorkspace.ts";

export const useWorkspaceFonts = () => {
  const { workspace } = useWorkspace();

  const brandFonts = workspace.brands.filter((brand) => brand.type === "FONT");

  return {
    workspaceFonts: brandFonts.filter((font) => !font.is_builtin),
    builtinFonts: brandFonts.filter((font) => font.is_builtin),
  };
};
